import React from "react";
import JourneyBuilderConfig from "../components/journey-builder/ViberMessageActivity";

const JourneyBuilder = () => {
  return <JourneyBuilderConfig />;
};

export default JourneyBuilder;